import { API_GET_ALL_NURSE, API_GET_ALL_NETWORKS } from "actions/nurse";

export function getAllNurses() {
	return {
		type: API_GET_ALL_NURSE,
		payload: {
			request: {
				url: `/nurses`,
			},
		},
	};
}

export function getAllNetworks() {
	return {
		type: API_GET_ALL_NETWORKS,
		payload: {
			request: {
				url: `/networks`,
			},
		},
	};
}
